import React from "react";

import { Typography } from "Components/atoms/Typography";
import { PriceWrapper, SeeMoreButton, StyledFlightPrice } from "./styles";
import { FlightPriceProps } from "./types";

import { Icon } from "Components/atoms/Icon";
import { formatCurrency } from "shared/utils/prices";

/**
 * Componente FlightPriceMobile
 *
 * Exibe o preço de um voo formatado com a moeda e um botão de ação.
 *
 * @param {number} price - Valor numérico do preço do voo.
 * @param {string} currency - Símbolo da moeda a ser exibido junto ao preço.
 * @param {() => void} [onButtonClick] - Callback executado ao clicar no botão "Veja mais".
 */
export const FlightPriceMobile: React.FC<FlightPriceProps> = ({
  price,
  currency,
  onButtonClick,
}) => (
  <StyledFlightPrice>
    <PriceWrapper>
      <Typography as="span" variant="caption" color="white" weight="light">
        {currency}
      </Typography>
      &nbsp;
      <Typography as="span" variant="h3" color="white" weight="bold">
        {formatCurrency(price).first}
      </Typography>
      <Typography as="span" variant="caption" color="white" weight="bold">
        ,{formatCurrency(price).second}
      </Typography>
    </PriceWrapper>
    <SeeMoreButton
      onClick={(event) => {
        event.stopPropagation();
        onButtonClick?.();
      }}
    >
      <Typography
        as="span"
        variant="caption"
        color="black"
        weight="bold"
        uppercase
      >
        Veja mais
      </Typography>
      <Icon library="md" name="MdArrowForwardIos" size="small" color="black" />
    </SeeMoreButton>
  </StyledFlightPrice>
);
